import { Receituario } from '_metronic/helpers/enums'

export const ROTULO_RECEITUARIO: Record<Receituario, string> = {
  [Receituario.Simples]: 'Simples — receita comum',
  [Receituario.RCE]: 'RCE — Receita de Controle Especial',
  [Receituario.RET]: 'RET — Receita com Retenção',
  [Receituario.NRA]: 'NRA — Notificação de Receita A (amarela)',
  [Receituario.NRB]: 'NRB — Notificação de Receita B (azul)',
  [Receituario.NRB2]: 'NRB2 — Notificação de Receita B2 (anorexígenos)',
  [Receituario.NRR]: 'NRR — Notificação de Receita de Retinoides',
  [Receituario.NRT]: 'NRT — Notificação de Receita de Talidomida (não emitida pela LauduzOne)',
}

/** Para etiquetas curtas na lista de itens da prescrição. */
export const ROTULO_CURTO_RECEITUARIO: Record<Receituario, string> = {
  [Receituario.Simples]: 'Simples',
  [Receituario.RCE]: 'Controle Especial',
  [Receituario.RET]: 'Retenção de receita',
  [Receituario.NRA]: 'Notificação A',
  [Receituario.NRB]: 'Notificação B',
  [Receituario.NRB2]: 'Notificação B2',
  [Receituario.NRR]: 'Notificação de Retinoides',
  [Receituario.NRT]: 'Notificação de Talidomida',
}

/**
 * A plataforma emite este receituário? Talidomida fica de fora: o modelo da Anvisa pede responsável
 * pelo paciente e cadastro Anvisa do médico, que o Lauduz não tem. Espelha `Receituario.isEmissaoDisponivel`.
 */
export const isEmissaoDisponivel = (receituario?: Receituario | null) =>
  receituario !== Receituario.NRT

/**
 * Termo que a Anvisa exige junto com a receita, pela lista do medicamento (Portaria 344/98 para
 * retinoides, RDC 50/2014 para anorexígenos). Só informação nesta etapa; o backend não guarda.
 */
export const termoUsoDoReceituario = (receituario?: Receituario | null): string | undefined => {
  if (receituario === Receituario.NRR) {
    return 'Termo de Conhecimento de Risco e Consentimento Pós-Informação (retinoide sistêmico), assinado pelo paciente e pelo prescritor'
  }
  if (receituario === Receituario.NRB2) {
    return 'Termo de Responsabilidade do Prescritor (anorexígeno), assinado pelo prescritor e pelo paciente, em três vias'
  }
  return undefined
}

export const RECEITUARIOS_OPTIONS = (Object.keys(ROTULO_RECEITUARIO) as Receituario[]).map(
  (value) => ({ value, label: ROTULO_RECEITUARIO[value] })
)
